"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoTokenTypeToJSON = exports.PromoTokenTypeFromJSONTyped = exports.PromoTokenTypeFromJSON = exports.PromoTokenType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PromoTokenType;
(function (PromoTokenType) {
    PromoTokenType["EXTERNALURL"] = "EXTERNAL_URL";
    PromoTokenType["COUPONCODE"] = "COUPON_CODE";
    PromoTokenType["QRCODE"] = "QR_CODE";
})(PromoTokenType = exports.PromoTokenType || (exports.PromoTokenType = {}));
function PromoTokenTypeFromJSON(json) {
    return PromoTokenTypeFromJSONTyped(json, false);
}
exports.PromoTokenTypeFromJSON = PromoTokenTypeFromJSON;
function PromoTokenTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PromoTokenTypeFromJSONTyped = PromoTokenTypeFromJSONTyped;
function PromoTokenTypeToJSON(value) {
    return value;
}
exports.PromoTokenTypeToJSON = PromoTokenTypeToJSON;
